import { apiFetch } from './client';

const DAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export function normalizeStore(raw) {
  const store = raw?.store || raw || {};
  const weekly = {};
  (store.weekly || []).forEach((entry) => {
    const label = DAY_LABELS.find((d) => d.toLowerCase() === entry.day);
    if (!label) return;
    weekly[label] = {
      open: !!entry.open,
      opensAt: entry.open_time,
      closesAt: entry.close_time,
    };
  });
  return {
    timezone: store.timezone || 'Asia/Kolkata',
    weekly,
    emergencyClosed: !!store.emergency_closed,
    emergencyReason: store.emergency_reason || null,
    isOpenNow: !!store.is_open_now,
  };
}

function toWeeklyPayload(weekly) {
  return DAY_LABELS.map((label) => {
    const d = weekly[label] || {};
    return {
      day: label.toLowerCase(),
      open: !!d.open,
      open_time: d.opensAt || '00:00',
      close_time: d.closesAt || '00:00',
    };
  });
}

export async function getStoreHours(token) {
  const raw = await apiFetch('/config/store', { token });
  return normalizeStore(raw);
}

export async function updateStoreHours(weekly, token) {
  const raw = await apiFetch('/config/store', {
    method: 'PUT',
    token,
    body: { weekly: toWeeklyPayload(weekly) },
  });
  return normalizeStore(raw);
}

export async function setEmergencyStatus({ closed, reason }, token) {
  const raw = await apiFetch('/config/store/emergency', {
    method: 'PUT',
    token,
    body: closed ? { emergency_closed: true, reason } : { emergency_closed: false },
  });
  return normalizeStore(raw);
}
